
export const data = [
	{
		to: '/',
		text: 'Početna',
		id: 'about',
	},
	{
		to: '/pricing',
		text: 'Proizvodi',
	},
	{
		to: '/signup',
		text: 'Kontakt',
	},
];



export const logoData = {
img: "./assets/whiterabbit.png"

}
